import PropTypes from 'prop-types'
import { PropTypes as MobXPropTypes } from 'mobx-react'
import React, { Component } from 'react'

export default class IndexList extends Component {

  static propTypes = {
    className: PropTypes.string,
    keyString: PropTypes.string,
    list: MobXPropTypes.observableArray.isRequired,
  }

  render() {

    const aCharCode = 'A'.charCodeAt(0)
    const zCharCode = 'Z'.charCodeAt(0)

    const items = this.props.list
      .map((item) => {
        return item[this.props.keyString].toUpperCase().charCodeAt(0)
      })
      .reduce((memo, item) => {
        if (memo.indexOf(item) === -1) {
          memo.push(item)
        }
        return memo
      }, [])
      .sort()

    let letterCodes = []
    let charCode = aCharCode
    while (charCode <= zCharCode) {
      letterCodes.push(charCode)
      charCode += 1
    }

    letterCodes = letterCodes.map((itm) => ({
      name: String.fromCharCode(itm),
      active: items.indexOf(itm) !== -1,
    }))

    return (
      <div
        className={
          [this.props.className, 'index-initials'].join(' ').trim()
        }
      >
        {letterCodes.map((code) => {
          if (code.active) {
            return (
              <a
                key={code.name}
                href={`#${code.name.toUpperCase()}`}
              >
                {code.name}
              </a>
            )
          }
          return (
            <span
              key={code.name}
            >
              {code.name}
            </span>
          )
        })}
      </div>
    )
  }

}



// WEBPACK FOOTER //
// ./src/shared/components/IndexList.js